import {RemotePatchConfirmAddressV4} from 'data/usecases';
import {PatchConfirmAddressV4} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makePatchConfirmAddressV4 = (sequence: number): PatchConfirmAddressV4 => {
	const addressConfirmV4Endpoint = ProfileChangeDataEndpoints.addressConfirmV4.replace(
		':sequence',
		sequence.toString(),
	);
	return new RemotePatchConfirmAddressV4(
		makeBFFApiUrl(addressConfirmV4Endpoint),
		makeAuthorizeHttpClientDecorator(),
	);
};
